import type { NodeMock, StatePreset } from "./mock-types";

export { CHAR_POOL, getPlayerTeam } from "./mock-utils";

import { autoBalanceMock, autoBalancePresets } from "./auto-balance/mocks";
import { captainDraftMock, captainDraftPresets } from "./captain-draft/mocks";
import { characterBanMock, characterBanPresets } from "./character-ban/mocks";
import { characterPickMock, characterPickPresets } from "./character-pick/mocks";
import { flowStartMock, flowStartPresets } from "./flow-start/mocks";
import { gameModeSelectMock, gameModeSelectPresets } from "./game-mode-select/mocks";
import { hostInstructionsMock, hostInstructionsPresets } from "./host-instructions/mocks";
import { lobbyCodeInputMock, lobbyCodeInputPresets } from "./lobby-code-input/mocks";
import { lobbyCreatedMock, lobbyCreatedPresets } from "./lobby-created/mocks";
import { mapBanMock, mapBanPresets } from "./map-ban/mocks";
import { mapVoteMock, mapVotePresets } from "./map-vote/mocks";
import { matchCancelledMock, matchCancelledPresets } from "./match-cancelled/mocks";
import { matchStartMock, matchStartPresets } from "./match-start/mocks";
import { readyUpMock, readyUpPresets } from "./ready-up/mocks";
import { selfSelectMock, selfSelectPresets } from "./self-select/mocks";
import { sideSelectMock, sideSelectPresets } from "./side-select/mocks";
import { teamVoiceSplitMock, teamVoiceSplitPresets } from "./team-voice-split/mocks";
import { voiceChannelJoinMock, voiceChannelJoinPresets } from "./voice-channel-join/mocks";

export const NODE_MOCKS: Record<string, NodeMock> = {
  flow_start: flowStartMock,
  ready_up: readyUpMock,
  map_vote: mapVoteMock,
  map_ban: mapBanMock,
  auto_balance: autoBalanceMock,
  captain_draft: captainDraftMock,
  self_select: selfSelectMock,
  match_start: matchStartMock,
  match_cancelled: matchCancelledMock,
  game_mode_select: gameModeSelectMock,
  character_ban: characterBanMock,
  character_pick: characterPickMock,
  side_select: sideSelectMock,
  host_instructions: hostInstructionsMock,
  lobby_code_input: lobbyCodeInputMock,
  lobby_created: lobbyCreatedMock,
  voice_channel_join: voiceChannelJoinMock,
  team_voice_split: teamVoiceSplitMock,
};

export const NODE_TYPES = Object.keys(NODE_MOCKS);

export const NODE_PRESETS: Record<string, StatePreset[]> = {
  flow_start: flowStartPresets,
  ready_up: readyUpPresets,
  map_vote: mapVotePresets,
  map_ban: mapBanPresets,
  auto_balance: autoBalancePresets,
  captain_draft: captainDraftPresets,
  self_select: selfSelectPresets,
  match_start: matchStartPresets,
  match_cancelled: matchCancelledPresets,
  game_mode_select: gameModeSelectPresets,
  character_ban: characterBanPresets,
  character_pick: characterPickPresets,
  side_select: sideSelectPresets,
  host_instructions: hostInstructionsPresets,
  lobby_code_input: lobbyCodeInputPresets,
  lobby_created: lobbyCreatedPresets,
  voice_channel_join: voiceChannelJoinPresets,
  team_voice_split: teamVoiceSplitPresets,
};
